import { ThreeDotsLoader } from "../../../../../../../components";
import styles from "./card-subtitle.module.scss";

const Loading = () => (
  <div
    className={styles.loading}
    data-testid="report_summary_subheader_loading_indicator"
  >
    <span>Loading</span>
    <ThreeDotsLoader height={6} />
  </div>
);

export default Loading;
